const Module3 = () => {
  return (
    <div className="footer">
      <p>Coming Soon</p>
      <p>Copyright 2023</p>
    </div>
  );
};

export default Module3;
